import { render } from "./RequestEmailToken.vue?vue&type=template&id=764b9226"
import script from "./RequestEmailToken.vue?vue&type=script&lang=js"
export * from "./RequestEmailToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/newAccount/RequestEmailToken.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "764b9226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('764b9226', __exports__)) {
    api.reload('764b9226', __exports__)
  }
  
  module.hot.accept("./RequestEmailToken.vue?vue&type=template&id=764b9226", () => {
    api.rerender('764b9226', render)
  })

}


export default __exports__